import React from 'react'
import { Table } from '../../../../components/Table/Table'
import plusCircle from '../../../../../assets/img/plusCircle.png'
import { addToConsignmentsBag } from '../../../../../actions/inventoryActions'
import { useDispatch } from 'react-redux'
import ButtonIcon from '../../../../../utils/components/ButtonIcon/ButtonIcon'
import { SaleBag } from '../../../../../assets/icons'
import { useHistory } from 'react-router-dom'
import style from './CreateConsignment.module.css'

const CreateConsignment = ({ products, string, setString, franchises, representatives, entity, setEntity }) => {
    const dispatch = useDispatch()
    const history = useHistory()
    return (
        <div>

            <Table  >
                <thead>
                    <tr>
                        <th>Codigo</th>
                        <th>Producto</th>
                        <th>Cantidad en stock</th>
                        <th>Agregar</th>
                    </tr>
                </thead>
                <tbody>
                    {
                        products.map(product => (
                            <tr key={product._id}>
                                <td>{product.products[0].code}</td>
                                <td>{product.products[0].name}</td>
                                <td>{product.stocks}</td>
                                <td>
                                    <img className="animate__animated animate__bounceIn" onClick={() => {

                                    dispatch(addToConsignmentsBag(product.products[0], product.stocks));
                                   // setisVisibleIconCart(true);
                                }} src={plusCircle} height={30} alt="" />
                                </td>
                            </tr>
                        ))
                    }
                </tbody>
            </Table>
            <ButtonIcon
                onClick={()=>{history.push("/Admin/Inventory/CreateConsignment/Cart")}}
                style={style}
                Icon={SaleBag}
                isIconCircle={true}
                text='Consignar'
            
                isVisible={true}
                animation= "animate__animated animate__fadeIn"
                widthCircle="5vw"
                widthIcon="3vw"

            />
            
        </div>
    )
}

export default CreateConsignment